import { render, staticRenderFns } from "./TeachIndex.vue?vue&type=template&id=73c06aa0&scoped=true"
import script from "./TeachIndex.vue?vue&type=script&lang=js"
export * from "./TeachIndex.vue?vue&type=script&lang=js"
import style0 from "./TeachIndex.vue?vue&type=style&index=0&id=73c06aa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c06aa0",
  null
  
)

export default component.exports